// formUi/SubmitBtn.js

export class SubmitBtn {
  constructor({ app, node }) {
    this.app = app;
    this.node = node;

    if (!this.node) return;

    this.node.addEventListener('click', (e) => {
      e.preventDefault(); // <button type="submit"> の場合は送信を止める
      this.handleClick();
    });
  }

  async handleClick() {
    const { aicAPIBaseURI, wpAPIBaseURI, wpApiKey } = this.app.store.config;

    // 🔸 必須項目が空なら叩かない（お好みで）
    const startSpot = this.app.getState('startSpot');
    const duration = this.app.getState('duration');
    const days = this.app.getState('days');
    const transportation = this.app.getState('transportation');

    if (!startSpot || !duration || !days || !transportation) {
      alert('出発地・所要時間・日数・移動手段を選択してください');
      return;
    }
    const queryString = this.app.getQueries();
    const aicUrl = `${aicAPIBaseURI}?${queryString}`;

    this.app.setState('isFetching', true);
    this.app.setState('hasValidSpotData', false);

    try {
      // 1) AIC API を叩く
      console.log('[SubmitBtn] fetch AIC:', aicUrl);

      const aicRes = await fetch(aicUrl);
      if (!aicRes.ok) {
        throw new Error(`AIC API error: ${aicRes.status}`);
      }
      const aicData = await aicRes.json();

      console.log('[SubmitBtn] aicData:', aicData);

      // ★★★ ここがポイント ★★★
      // 本体は aicData.response に入っている
      const aicResponse = aicData.response || {};
      console.log('[SubmitBtn] aicResponse:', aicResponse);
      console.log(
        '[SubmitBtn] aicResponse.plan_infos:',
        aicResponse.plan_infos
      );

      // Aic 側の state には response だけを入れる
      this.app.setState('aicAPIInfo', aicResponse);

      // 2) IDs 抽出
      // 2-1. plan_infos から spot_id を集める（あれば）
      const fromPlanInfos = Array.isArray(aicResponse.plan_infos)
        ? aicResponse.plan_infos
            .map((info) => info.spot_id)
            .filter((id) => id != null && id !== '')
        : [];

      // 2-2. jtp_spot_ids（文字列）からも取る（メイン）
      let fromJtp = [];
      if (aicResponse.jtp_spot_ids) {
        try {
          // '[521590230, 521590137, ...]' → [521590230, 521590137, ...]
          const parsed = JSON.parse(aicResponse.jtp_spot_ids);
          if (Array.isArray(parsed)) {
            fromJtp = parsed.filter((id) => id != null && id !== '');
          }
        } catch (e) {
          console.warn('[SubmitBtn] failed to parse jtp_spot_ids', e);
        }
      }

      // 2-3. startスポットもあれば ID に含める
      const fromStart = aicResponse.jtp_start_spot_id
        ? [Number(aicResponse.jtp_start_spot_id)]
        : [];

      // 2-4. まとめて重複排除
      const ids = [...new Set([...fromPlanInfos, ...fromJtp, ...fromStart])];

      console.log('[SubmitBtn] spot ids for WP API:', ids);

      if (!ids.length) {
        this.app.setState('wpAPIInfo', []);
        this.app.setState('hasValidSpotData', false);
        return;
      }

      // 3) WP API を叩く
      let lang = this.app.store.config.locale; // 'ja' / 'en' / 'zh-hant' / 'th'

      // ベースURL
      let wpUrl = `${wpAPIBaseURI}?apikey=${wpApiKey}&ids=${ids.join(',')}&lang=${encodeURIComponent(lang)}`;

      // ★ 日本語の時だけ /ja/ を取り除く
      if (lang === 'ja') {
        wpUrl = wpUrl.replace('/ja/spot-api-for-aic/', '/spot-api-for-aic/');
      }

      console.log('[SubmitBtn] fetch WP:', wpUrl);

      const wpRes = await fetch(wpUrl);
      if (!wpRes.ok) {
        throw new Error(`WP API error: ${wpRes.status}`);
      }
      const wpData = await wpRes.json();

      console.log('[SubmitBtn] wpData ALL:', wpData);

      // ★ ここで locale === 'en' だけを抽出
      const wpDataEn = wpData.filter((spot) => spot.locale === 'en');
      console.log('[SubmitBtn] wpData EN only:', wpDataEn);

      // そのまま state に保存
      this.app.setState('wpAPIInfo', wpData);
    } catch (error) {
      console.error('[SubmitBtn] fetch error', error);
      this.app.setState('hasValidSpotData', false);
    } finally {
      this.app.setState('isFetching', false);
    }
    
    this.app.scrollAppTopLoc();
  }
}
